"use strict";
/* eslint-disable */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SubWorker_1 = __importDefault(require("./SubWorker"));
var util_1 = require("./util");
var WorkerBridge = /** @class */ (function () {
    function WorkerBridge(callback) {
        var _this = this;
        this.callback = callback;
        this.seguroInitDataTemp = undefined;
        this.testPasscode = function (passcode, progressCallback) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'encrypt_TestPasscode',
                    data: [passcode]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        return resolve(['FAILURE']);
                    }
                    var data = _cmd.data[0];
                    if (typeof data === 'number') {
                        var t = data * 100;
                        var u = Math.round(t - 0.5);
                        var p = t - u - 0.005;
                        p = p < 0 ? 0 : p;
                        return progressCallback(u.toString(), p.toFixed(2));
                    }
                    return resolve(['SUCCESS', _this.initUIMethod(data)]);
                });
            });
        };
        this.isAddress = function (address) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'isAddress',
                    data: [address]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('createPasscode ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    return resolve(['SUCCESS', _cmd.data[0]]);
                });
            });
        };
        this.mintCoNETCash = function (usdcVal, keyID) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'mintCoNETCash',
                    data: [[usdcVal, keyID]]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('createPasscode ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    return resolve(['SUCCESS', _cmd.data[0]]);
                });
            });
        };
        this.createPasscode = function (passcode, progressCallback) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'encrypt_createPasscode',
                    data: [passcode, _this.seguroInitDataTemp]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('createPasscode ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    var data = _cmd.data[0] || null;
                    if (typeof data === 'number') {
                        var t = (data * 100);
                        var u = Math.round(t - 0.5);
                        var p = t - u - 0.005;
                        p = p < 0 ? 0 : p;
                        return progressCallback(u.toString(), p.toFixed(2));
                    }
                    return resolve(['SUCCESS', _this.initUIMethod(data)]);
                });
            });
        };
        this.invitation = function (code) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'invitation',
                    data: [code]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('invitation ERROR', err.message);
                        //@ts-ignore
                        return resolve(err.message);
                    }
                    var data = _cmd.data[0];
                    _this.initUIMethod(data);
                    return resolve('SUCCESS');
                });
            });
        };
        this.syncAsset = function () {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'syncAsset',
                    data: []
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('syncAsset ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_this.seguroInitDataTemp)
                        _this.seguroInitDataTemp.data = _cmd.data[0];
                    return resolve(['SUCCESS']);
                });
            });
        };
        this.lock = function () {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'encrypt_lock'
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('Lock ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    var data = _cmd.data[0];
                    return resolve(['SUCCESS', _this.initUIMethod(data)]);
                });
            });
        };
        this.deletePasscode = function () {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'encrypt_deletePasscode'
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('deletePasscode ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    var data = _cmd.data[0];
                    return resolve(['SUCCESS', _this.initUIMethod(data)]);
                });
            });
        };
        this.storePreferences = function () {
            return new Promise(function (resolve) {
                if (!_this.seguroInitDataTemp) {
                    return resolve(['NOT_READY']);
                }
                var cmd = {
                    cmd: 'storePreferences',
                    data: [_this.seguroInitDataTemp.preferences]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('storePreferences ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    return resolve(['SUCCESS']);
                });
            });
        };
        this.newProfile = function (profile) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'newProfile',
                    data: [profile]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('newProfile ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_cmd.err) {
                        return resolve(['SYSTEM_ERROR']);
                    }
                    return resolve(['SUCCESS', _this.initUIMethod(_cmd.data[0])]);
                });
            });
        };
        this.storeProfile = function () {
            return new Promise(function (resolve) {
                var _a;
                var cmd = {
                    cmd: 'storeProfile',
                    data: [(_a = _this.seguroInitDataTemp) === null || _a === void 0 ? void 0 : _a.data.profiles]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('storeProfile ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_cmd.err) {
                        (0, util_1.logger)('storeProfile _cmd.err', _cmd.err);
                        return resolve(['SYSTEM_ERROR']);
                    }
                    return resolve(['SUCCESS']);
                });
            });
        };
        this.getFaucet = function (walletAddr) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'getFaucet',
                    data: [walletAddr]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('getFaucet ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_cmd.err) {
                        (0, util_1.logger)('getFaucet _cmd.err', _cmd.err);
                        return resolve(['SYSTEM_ERROR']);
                    }
                    return resolve(['SUCCESS']);
                });
            });
        };
        this.sendAsset = function (sendAddr, total, toAddr, asset) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'sendAsset',
                    data: [[sendAddr, total, toAddr, asset]]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('sendAsset ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_cmd.err) {
                        (0, util_1.logger)('sendAsset _cmd.err', _cmd.err);
                        return resolve(['SYSTEM_ERROR']);
                    }
                    return resolve(['SUCCESS']);
                });
            });
        };
        this.getRecipientCoNETCashAddress = function (amount, CallBack) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'getRecipientCoNETCashAddress',
                    data: [amount]
                };
                var first = true;
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (first) {
                        first = false;
                        if (err) {
                            (0, util_1.logger)('getRecipientCoNETCashAddress ERROR', err);
                            return resolve(['NOT_READY']);
                        }
                        if (_cmd.err) {
                            (0, util_1.logger)('sendAsset _cmd.err', _cmd.err);
                            return resolve(['SYSTEM_ERROR']);
                        }
                        return resolve(['SUCCESS', _cmd.data[0]]);
                    }
                    CallBack(_cmd.data[0]);
                });
            });
        };
        this.getUSDCPrice = function () {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'getUSDCPrice',
                    data: []
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('sendAsset ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_cmd.err) {
                        (0, util_1.logger)('sendAsset _cmd.err', _cmd.err);
                        return resolve(['SYSTEM_ERROR']);
                    }
                    return resolve(['SUCCESS', _cmd.data[0]]);
                });
            });
        };
        this.buyUSDC = function (conetVal, keyID) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'buyUSDC',
                    data: [[conetVal, keyID]]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('sendAsset ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_cmd.err) {
                        (0, util_1.logger)('sendAsset _cmd.err', _cmd.err);
                        return resolve(['SYSTEM_ERROR']);
                    }
                    return resolve(['SUCCESS', _cmd.data[0]]);
                });
            });
        };
        this.getSINodes = function (sortby, region) {
            return new Promise(function (resolve) {
                var _cmd = {
                    cmd: 'getSINodes',
                    data: [[sortby, region]]
                };
                return _this.encryptWorker.append(_cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('sendAsset ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_cmd.err) {
                        (0, util_1.logger)('sendAsset _cmd.err', _cmd.err);
                        return resolve(['SYSTEM_ERROR']);
                    }
                    return resolve(['SUCCESS', _cmd.data[0]]);
                });
            });
        };
        this.getUserProfile = function (walletAddr) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'getUserProfile',
                    data: [walletAddr]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('getFaucet ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_cmd.err) {
                        (0, util_1.logger)('getFaucet _cmd.err', _cmd.err);
                        return resolve(['SYSTEM_ERROR']);
                    }
                    return resolve(['SUCCESS', _cmd.data[0]]);
                });
            });
        };
        this.sendMessage = function (keyAddress, message) {
            return new Promise(function (resolve) {
                var cmd = {
                    cmd: 'sendMessage',
                    data: [keyAddress, message]
                };
                return _this.encryptWorker.append(cmd, function (err, _cmd) {
                    if (err) {
                        (0, util_1.logger)('getFaucet ERROR', err);
                        return resolve(['NOT_READY']);
                    }
                    if (_cmd.err) {
                        (0, util_1.logger)('getFaucet _cmd.err', _cmd.err);
                        return resolve(['SYSTEM_ERROR']);
                    }
                    return resolve(['SUCCESS', _cmd.data[0]]);
                });
            });
        };
        this.encryptWorkerReady = false;
        this.encryptWorker = new SubWorker_1.default('/encrypt.js', function (init) {
            _this.encryptWorkerReady = true;
            var InitData = init[0];
            var setup = _this.initUIMethod(InitData);
            _this.callback(['SUCCESS', setup]);
            //         for TEST createPasscode
            // if ( setup ) {
            //     if ( setup.passcode.status === 'NOT_SET') {
            //         //@ts-ignore
            //         return setup.passcode.createPasscode('223344', (R,L) => {
            //             //logger (`process: [${ R }${L}]`)
            //         }).then(() => {
            //             logger('createPasscode SUCCESS', setup )
            //         })
            //     }
            // }
            // if ( setup?.passcode.status === 'NOT_SET') {
            //     if ( setup.passcode.createPasscode ) {
            //         return setup.passcode.createPasscode('223344', (R,L) => {
            //             //logger (`process: [${ R }${L}]`)
            //         }).then(() => {
            //             logger('createPasscode SUCCESS', setup )
            //         })
            //     }
            //     return logger (`!setup.passcode.createPasscode`)
            // }
            //      for TEST invitation
            // if ( setup?.passcode.status === 'NOT_SET') {
            //     if ( setup.passcode.createPasscode ) {
            //         return setup.passcode.createPasscode('223344', (R,L) => {
            //             //logger (`process: [${ R }${L}]`)
            //         }).then(() => {
            //             logger('createPasscode SUCCESS', setup )
            //         })
            //     }
            //     return logger (`!setup.passcode.createPasscode`)
            // }
            // if ( setup?.passcode.status === 'LOCKED') {
            //     if ( setup.passcode.testPasscode ) {
            //         return setup.passcode.testPasscode('223344', (pssL, pssR ) => {
            //             //return logger (`process: [${ pssL }][${pssR}]`)
            //         }).then((status) => {
            //             logger('testPasscode SUCCESS!', setup)
            //             if ( setup?.SeguroNetwork.invitation ) {
            //                 return setup?.SeguroNetwork.invitation ('C11A6BDB-4230-430E-AD5C-D36196BF2F70')
            //             }
            //             logger (`! setup?.seguroNetwork.invitation`)
            //         }).then( status => {
            //             if ( status !== 'SUCCESS') {
            //                 return logger('setup?.SeguroNetwork.invitation ERROR', status )
            //             }
            //             logger ('setup?.SeguroNetwork.invitation SUCCESS', setup)
            //         })
            //     }
            //    return logger (`!setup.passcode.testPasscode`)
            // }
            //      for TEST deletePasscode
            // if ( this.seguroInitDataTemp?.passcode.status === 'LOCKED') {
            //     return this.testPasscode('223344', () => {
            //         //logger (`process: [${ process }]`)
            //     }).then((n) => {
            //         logger('testPasscode SUCCESS!', n)
            //         return this.lock ()
            //     })
            //     .then (n => {
            //         logger (`Lock success!`, n )
            //         return this.deletePasscode ()
            //     })
            //     .then (n => {
            //         logger (`deletePasscode success!`, n )
            //     })
            // }
            // let setup: Type.ContainerData|undefined
            // //      test storePreferences
            // if ( this.seguroInitDataTemp?.passcode.status === 'LOCKED') {
            //     return this.testPasscode('223344', (pssL, pssR ) => {
            //         //return logger (`process: [${ pssL }][${pssR}]`)
            //     }).then((n) => {
            //         logger('testPasscode SUCCESS!', n)
            //         setup = n[1]
            //         const profile = this.seguroInitDataTemp?.profile.profiles[0]
            //         if ( profile ) {
            //             profile.alias = 'Carol'
            //             profile.nickname = 'Carol Yan'
            //             profile.tags = ['Kloak', 'woman']
            //             profile.nicknameMark = 'kkbb'
            //         }
            //         if ( setup && setup.profile.storeProfile ) {
            //             return setup.profile.storeProfile ()
            //         }
            //         logger(`( setup && setup.profiles.newProfile) === null`)
            //         //@ts-ignore
            //         // this.seguroInitDataTemp?.preferences.preferences = {
            //         //     uuuu: 'sadcsacd',
            //         //     oooo: 'hgvhsjkdclas'
            //         // }
            //         // return this.storePreferences()
            //     })
            //     .then (n => {
            //         logger (`storeProfile SUCCESS`)
            //         logger (this.seguroInitDataTemp)
            //     })
            //     // .then (n => {
            //     //     logger (`Lock success!`, n )
            //     // })
            // }
        }, function (message) {
            var data = message.data[0];
            if (!data) {
                return (0, util_1.logger)("SubWorker encrypt.js sent a null data!");
            }
            if (!_this.seguroInitDataTemp) {
                (0, util_1.logger)("this.seguroInitDataTemp is NULL ERROR!");
                return (0, util_1.logger)("Message from SubWorker encrypt.js ", data);
            }
            (0, util_1.logger)("WorkerBridge have message");
            (0, util_1.logger)(data);
        });
    }
    WorkerBridge.prototype.initUIMethod = function (data) {
        if (!this.seguroInitDataTemp) {
            if (!data || !data.passcode) {
                (0, util_1.logger)("initUIMethod have null of data and this.seguroInitDataTemp");
                return;
            }
            this.seguroInitDataTemp = {
                method: {},
                data: data,
                status: data.passcode.status,
                preferences: data.preferences
            };
        }
        this.seguroInitDataTemp.data = data;
        this.seguroInitDataTemp.preferences = data.preferences;
        var sw = this.seguroInitDataTemp.status = data.passcode.status;
        switch (sw) {
            case 'NOT_SET': {
                this.seguroInitDataTemp.method = {
                    createPasscode: this.createPasscode,
                    testPasscode: this.testPasscode
                };
                return this.seguroInitDataTemp;
            }
            case 'LOCKED': {
                this.seguroInitDataTemp.method = {
                    testPasscode: this.testPasscode,
                    deletePasscode: this.deletePasscode
                };
                return this.seguroInitDataTemp;
            }
            case 'UNLOCKED': {
                this.seguroInitDataTemp.method = {
                    deletePasscode: this.deletePasscode,
                    lock: this.lock,
                    storePreferences: this.storePreferences,
                    newProfile: this.newProfile,
                    storeProfile: this.storeProfile,
                    isAddress: this.isAddress,
                    getFaucet: this.getFaucet,
                    syncAsset: this.syncAsset,
                    sendAsset: this.sendAsset,
                    getUSDCPrice: this.getUSDCPrice,
                    buyUSDC: this.buyUSDC,
                    mintCoNETCash: this.mintCoNETCash,
                    getSINodes: this.getSINodes,
                    getRecipientCoNETCashAddress: this.getRecipientCoNETCashAddress,
                    getUserProfile: this.getUserProfile,
                    sendMessage: this.sendMessage
                };
                return this.seguroInitDataTemp;
            }
            default: {
                return this.seguroInitDataTemp;
            }
        }
    };
    return WorkerBridge;
}());
exports.default = WorkerBridge;
